// App.js
import React from "react";

/* MAIN APP COMPONENT */
const App = () => {
  return (
    <>
      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          body {
            font-family: Arial, sans-serif;
            background-color: #ffffff;
            overflow-x: hidden;
          }
          /* HEADER */
          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 20px;
            background-color: #d3d3d3;
          }
          .logo img { height: 30px; }
          .nav button {
            background: none;
            border: none;
            color: black;
            margin-left: 15px;
            cursor: pointer;
            font-size: 16px;
          }
          .nav button:hover { text-decoration: underline; }

          /* BANNER */
          .banner {
            width: 100%;
            background-color: #0061f2;
            padding: 40px 20px;
            display: flex;
            align-items: center;
            color: white;
          }
          .banner .image-container { flex: 0 0 250px; }
          .banner img { width: 100%; border-radius: 8px; }
          .banner .info { margin-left: 25px; }
          .banner .info h1 { font-size: 38px; font-weight: bold; }
          .banner .info h2 { margin-top: 10px; font-size: 20px; color: #e8e8e8; }
          .banner .info p { margin-top: 6px; font-size: 16px; }

          /* MAIN CONTENT */
          .content { width: 100%; margin: 0; padding: 0; }
          .lyrics-wrapper { max-width: 1100px; margin: 30px auto; padding: 0 20px; }
          .song-description { font-size: 18px; margin-bottom: 20px; color: #333; }
          .separator { width: 100%; height: 2px; background-color: #cccccc; margin: 20px 0; }
          .lyrics h3 { margin-top: 25px; font-size: 24px; font-weight: bold; }
          .lyrics p { font-size: 18px; color: #222; line-height: 1.6; margin-top: 8px; }
        `}
      </style>

      <Header />
      <Banner />

      <div className="content">
        <div className="lyrics-wrapper">
          <p className="song-description">
            "History Requiem: Beacon of Knowledge" explores self-growth, reflection, and the emotional battles that shape personal evolution.
          </p>

          <div className="separator"></div>

          <Lyrics />
        </div>
      </div>
    </>
  );
};

/* HEADER */
const Header = () => (
  <header className="header">
    <div className="logo">
      <img src="https://www.svgrepo.com/show/341838/genius.svg" alt="Genius Logo" />
    </div>

    <nav className="nav">
      <button>Music IQ</button>
      <button>Featured</button>
      <button>Charts</button>
      <button>Videos</button>
      <button>Promote Your Music</button>
      <button>Sign Up</button>
    </nav>
  </header>
);

/* BANNER */
const Banner = () => (
  <div className="banner">
    <div className="image-container">
      <img
        src="https://cdn.textstudio.com/output/sample/normal/7/4/9/3/ediz-logo-73-3947.png"
        alt="Album artwork"
      />
    </div>

    <div className="info">
      <h1>History Requiem: Beacon of Knowledge</h1>
      <h2>Beakon Of Knowledge</h2>
      <p>Producer: Blastoise70</p>
      <div className="track-info">
        <p>Debut release of ET</p>
        <p>Nov 3, 2017 • 1 Viewer • 434.9K Views</p>
      </div>
    </div>
  </div>
);

/* LYRICS */
const Lyrics = () => (
  <div className="lyrics">
    <h3>Verse 1</h3>
    <p>
      Look, I've been walking around my own thoughts and dreams,<br/>
      Eating my pride away and chasing the next path like a map.<br/>
      Whilst I'm walking around I'm seeing sparks everywhere in the sky,<br/>
      But one spark is missing in my heart and I can feel it.<br/>
      The feeling of wanting a life of happiness and success.<br/>
      As I'm surrounded in this crazy world I'm writing my first bar<br/>
      As if my life depends on it, knowing not to depend on luck.<br/>
      I'm only eighteen and as far as my life continues I ask myself,<br/>
      Why am I lying to myself?<br/>
      Asking myself, is fear controlling my life?<br/>
      I'm always stressing about the future and the past,<br/>
      But never the present.<br/>
    </p>

    <h3>Verse 2</h3>
    <p>
      I never want to rely on success to come knocking at my door.<br/>
      All distractions like wanting love,<br/>
      But really I just want to feel good about myself and find peace.<br/>
    </p>

    <h3>Verse 3</h3>
    <p>
      Seen the highs, seen the lows,<br/>
      Seen the friends, seen the foes,<br/>
      Seen the books circling around me.<br/>
      So I know I got a lot of years ahead of me<br/>
      To search the answer of my true history.<br/>
      Got to learning the books of my struggles,<br/>
      Questioning if that's all me.<br/>
      Letting myself flow through all these words I'm rhyming on,<br/>
      Being unobtrusive.<br/>
      Not letting attention relate to my own reality.<br/>
      With life, you challenge every obstacle,<br/>
      Not letting yourself get stuck in a maze<br/>
      And jump to each level.<br/>
      Beat different levels of the game,<br/>
      Feeling like I'm Super Mario.<br/>
    </p>

    <h3>Verse 4</h3>
    <p>
      Now I'm living in the moment,<br/>
      Now I'm holding my head high.<br/>
      Always learning and never afraid<br/>
      To learn from my own mistakes<br/>
      and punch them away like a boxing bag.<br/>
      As I got more takes on set,<br/>
      My communication is key<br/>
      To make your own history better.<br/>
      Don't forget.<br/>
    </p>

    <h3>Bridge</h3>
    <p>
      In life I was reminded on time—<br/>
      How it's precious, to never let it go to waste.<br/>
      Because time heals all wounds<br/>
      That the old me would never understand<br/>
      And definitely not let me sit down<br/>
      And work on my pen and craft.<br/>
      That craft is making me listen and learn<br/>
      On the many opportunities I have<br/>
      To keep pushing myself.<br/>
      The life I'm pushing is a sense of power through direction.<br/>
      Maybe that's why I'm writing this song,<br/>
      Feeling like this is a new sense of purpose<br/>
      That I'm storyboarding for myself.<br/>
      I'm acting abroad on many facades of characters<br/>
      That I'm putting first.<br/>
      Yeah, I have many exploring to do.<br/>
    </p>

    <h3>Outro</h3>
    <p>
      Myself with mercy on my side,<br/>
      Like I'm calling first.<br/>
      History is the way you can find it.<br/>
      I'll see you on the other side.<br/>
    </p>
  </div>
);

export default App;
